import EshopBasket from '../../eshopbootstrap/basket';

export default class Basket extends EshopBasket {

}